import { TYPE_AVERAGE, TYPE_SUM } from "@/helpers/constants";
import { configNumberFormatter, formatters } from "@/helpers/formatters";
import { HeatmapOutputDictionary } from "@/types/common";

export default <HeatmapOutputDictionary[]>[
  {
    title: "Budget",
    value: "channel_budget",
    tableGroup: "standard",
    formatter: formatters.formattedCurrencyNoFraction,
    type: TYPE_SUM,
    colors: { base: [149, 103, 217], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPM",
    value: "cpm",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [126, 196, 226], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Impressions",
    value: "impressions",
    tableGroup: "standard",
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
    colors: { base: [249, 103, 191], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Acquisitions",
    value: "acquisitions",
    tableGroup: "standard",
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
    colors: { base: [78, 80, 104], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "App Events",
    value: "app_events",
    tableGroup: "standard",
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
    colors: { base: [149, 103, 217], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "App Installs",
    value: "app_installs",
    tableGroup: "standard",
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
    colors: { base: [243, 98, 231], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Event Response",
    value: "event_response",
    tableGroup: "standard",
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
    colors: { base: [181, 222, 240], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Local Action",
    value: "local_action",
    tableGroup: "standard",
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
    colors: { base: [255, 178, 125], aMin: 0.2, aMax: 1.0 },
  },

  {
    title: "Bookings",
    value: "bookings",
    tableGroup: "standard",
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
    colors: { base: [231, 243, 98], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Clicks",
    value: "clicks",
    tableGroup: "standard",
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
    colors: { base: [125, 255, 178], aMin: 0.1, aMax: 0.7 },
  },
  {
    title: "Completed Views",
    value: "completed_views",
    tableGroup: "standard",
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
    colors: { base: [128, 150, 255], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Engagements",
    value: "engagements",
    tableGroup: "standard",
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
    colors: { base: [98, 231, 243], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Intent Actions",
    value: "intent_actions",
    tableGroup: "standard",
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
    colors: { base: [181, 156, 217], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Landing Page Visits",
    value: "landing_page_views",
    tableGroup: "standard",
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
    colors: { base: [243, 175, 237], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Leads",
    value: "leads",
    tableGroup: "standard",
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
    colors: { base: [255, 212, 183], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Link Clicks",
    value: "link_clicks",
    tableGroup: "standard",
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
    colors: { base: [98, 231, 243], aMin: 0.2, aMax: 0.75 },
  },
  {
    title: "Page Likes",
    value: "page_likes",
    tableGroup: "standard",
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
    colors: { base: [182, 188, 106], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Purchase Value",
    value: "purchase_value",
    tableGroup: "standard",
    formatter: formatters.currencyFormat,
    type: TYPE_SUM,
    colors: { base: [133, 158, 168], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Purchases",
    value: "purchases",
    tableGroup: "standard",
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
    colors: { base: [223, 235, 240], aMin: 0.2, aMax: 0.75 },
  },
  {
    title: "Site Action",
    value: "site_action",
    tableGroup: "standard",
    formatter: formatters.plainNumberWithSeparators,
    type: TYPE_SUM,
    colors: { base: [148, 107, 143], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Submissions/Entries",
    value: "submission_entries",
    tableGroup: "standard",
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
    colors: { base: [193, 146, 112], aMin: 0.2, aMax: 1.0 },
  },

  {
    title: "Store Visits",
    value: "store_visits",
    tableGroup: "standard",
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
    colors: { base: [78, 80, 104], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "Video Views",
    value: "video_views",
    tableGroup: "standard",
    formatter: formatters.numberFixedFormat,
    type: TYPE_SUM,
    colors: { base: [149, 103, 217], aMin: 0.2, aMax: 1.0 },
  },

  {
    title: "CPB",
    value: "cpb",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [243, 98, 231], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPC",
    value: "cpc",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [181, 222, 240], aMin: 0.2, aMax: 0.9 },
  },
  {
    title: "CPCV",
    value: "cpcv",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [255, 178, 125], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPE",
    value: "cpe",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [182, 188, 106], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPER",
    value: "cper",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [125, 255, 178], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPA",
    value: "cpa",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [128, 150, 255], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPAE",
    value: "cpae",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [98, 231, 243], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPI",
    value: "cpi",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [181, 156, 217], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPIA",
    value: "cpia",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [243, 175, 237], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPL",
    value: "cpl",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [255, 212, 183], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPLA",
    value: "cpla",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [241, 248, 163], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPLC",
    value: "cplc",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [182, 188, 106], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPLV",
    value: "cplv",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [133, 158, 168], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPP",
    value: "cpp",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [193, 146, 112], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPPL",
    value: "cppl",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [148, 107, 143], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPS",
    value: "cps",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [193, 146, 112], aMin: 0.2, aMax: 1.0 },
  },

  {
    title: "CPSA",
    value: "cpsa",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [78, 80, 104], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CPSV",
    value: "cpsv",
    tableGroup: "calculated",
    formatter: formatters.formattedCurrencyTwoDecimals,
    type: TYPE_AVERAGE,
    colors: { base: [149, 103, 217], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "CTR",
    value: "ctr",
    tableGroup: "calculated",
    formatter: formatters.numberFixedFormat,
    type: TYPE_AVERAGE,
    colors: { base: [243, 98, 231], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "ROAS",
    value: "roas",
    tableGroup: "calculated",
    formatter: formatters.numberFixedFormat,
    configFormatter: configNumberFormatter.numberFixedFormat,
    type: TYPE_AVERAGE,
    colors: { base: [181, 222, 240], aMin: 0.2, aMax: 1.0 },
  },
  {
    title: "VCR",
    value: "vcr",
    tableGroup: "calculated",
    formatter: formatters.numberFixedFormat,
    type: TYPE_AVERAGE,
    colors: { base: [255, 178, 125], aMin: 0.2, aMax: 1.0 },
  },
];
